import { render, staticRenderFns } from "./tui.vue?vue&type=template&id=49f30164&scoped=true"
import script from "./tui.vue?vue&type=script&lang=js"
export * from "./tui.vue?vue&type=script&lang=js"
import style0 from "./tui.vue?vue&type=style&index=0&id=49f30164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f30164",
  null
  
)

export default component.exports